import React, { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import Button from "./Button";

const NewModal = (props) => {
  const { label, renameBoard } = props;
  const [boardName, setBoardName] = useState("");
  const [show, setShow] = useState(true);
  useEffect(() => {
    setBoardName(renameBoard.name);
    setShow((state) => {
      return { ...state, show: !state.show };
    });
  }, [renameBoard]);

  const closemodalHandler = () => {
    setShow(!show);
  };

  const boardNameChange = (event) => {
    setBoardName(event.target.value);
  };
  const onBoardNameSubmit = (event) => {
    event.preventDefault();
    const boardnewdata = { name: boardName, set_key: renameBoard.key };
    setShow(!show);
    props.nameOnChangeHandler(boardnewdata);
  };
  return (
    <div class="adding-content" style={{ display: show ? "block" : "none" }}>
      <Form onSubmit={onBoardNameSubmit}>
        <Form.Control
          type="text"
          value={boardName}
          onChange={boardNameChange}
        />
        <Button text="Submit" className="muBtn _blue sm mt-3" type="submit" />{" "}
        &nbsp;
        <Button
          text="Cancel"
          type="button"
          className="muBtn _light border sm mt-3"
          onClick={closemodalHandler}
        />
      </Form>
    </div>
  );
};

export default NewModal;
